<div *ngIf="isTooltipToBeShown()" class="wrapper" [ngClass]="{'wrapper-login': login,
    'desktop':isUhfTooltip,
    'tabMobile':!isUhfTooltip && data.mobileDisplay=='TRUE',
    'space-below':!(data.bottomLiner && data.bottomCta)}">
  <div *ngIf="isUhfTooltip" class="tip-container">
    <div class="tip"></div>
    <div class="tip2"></div>
  </div>
  <div class="top">
    <i class="material-icons icon">notifications</i>
    <span class="first-text">{{ data.topLiner }}</span>
  </div>
  <div (click)="openTheLink($event,'top')" class="buttontop">{{ data.topCta }}</div>
  <ng-container *ngIf="isUhfTooltip && data.bottomLiner && data.bottomCta">
    <hr class="hr-tooltip">
    <div class="bottom">
      <div class="signup-text">{{ data.bottomLiner }}</div>
      <div (click)="openTheLink($event,'bottom')" class="signup">{{ data.bottomCta }}</div>
    </div>
  </ng-container>
</div>
